import { render } from "./CheckupForm.vue?vue&type=template&id=01246474"
import script from "./CheckupForm.vue?vue&type=script&lang=js"
export * from "./CheckupForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__